'use client';
import React, { Ref } from 'react';

import CloseIcon from '@/assets/icons/close.svg';

import { useIsMobile } from '../../../hooks/use-is-mobile';
import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import { ILibraryMenuGroup } from '../../../lib/fragments/libraryMenuGroup';
import { BlockSections } from '../../blocks/block-sections';
import { RenderBlocks } from '../../blocks/render-blocks';
import { ITextAndImageCardBlock } from '../../../lib/fragments/textAndImageCardBlock';
import { FoldOutMenuSubMenu } from '../../fold-out-menu/fold-out-menu-submenu';
import ImageWrapper from '../../image-wrapper/Image-wrapper';
import styles from './china-fold-out-menu.module.scss';

interface ChinaFoldOutMenuProps {
  el: Ref<HTMLDivElement> | undefined;
  toggleMenu: () => void;
  logo?: IContentfulImage;
  menuGroups: ILibraryMenuGroup[];
  menuCards: ITextAndImageCardBlock[];
  menuClass: string;
}

export const ChinaFoldOutMenu = ({
  el,
  toggleMenu,
  logo,
  menuGroups,
  menuCards,
  menuClass,
}: ChinaFoldOutMenuProps) => {
  const isMobile = useIsMobile();

  return (
    <div
      ref={el}
      id="main-menu"
      className={`fixed left-0 bottom-0 z-50 -mb-5 ml-[50%] w-screen -translate-x-1/2 rounded-t-xl bg-brand-white shadow-default transition-all duration-300 ease-out lg:top-0 lg:bottom-auto lg:ml-0 lg:mb-auto lg:max-h-full lg:w-full lg:translate-x-0 lg:animate-fadeIn lg:overflow-y-auto lg:rounded-b-xl lg:rounded-t-none ${menuClass}`}
    >
      <button
        className="fixed -top-20 right-4 z-40 grid h-12 w-12 place-items-center rounded-full bg-brand-grey-1 outline-0 transition-all lg:hover:bg-brand-grey-2 focus:bg-brand-grey-2 focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-brand-grey-2 active:bg-brand-grey-2 lg:hidden"
        onClick={toggleMenu}
      >
        <CloseIcon />
        <span className="sr-only">Close menu</span>
      </button>
      <div className="container relative">
        <div className="max-lg:mobilemenuheight scrollbar-mt relative overflow-y-auto rounded-b-xl px-6 text-neutral-grey-900 xl:container max-lg:rounded-t-xl lg:px-0">
          <div className="relative mt-6 hidden flex-row items-center justify-between lg:flex">
            {logo && (
              <ImageWrapper
                className="max-h-10 w-36"
                alt={''}
                url={logo?.url}
                height={logo?.height ? parseInt(logo?.height) : 60}
                width={140}
                imgClassName="max-h-10 !w-auto"
              />
            )}
            <button
              className="z-40 hidden h-15 w-15 place-items-center rounded-full bg-brand-yellow-1 outline-0  transition-all  lg:hover:bg-accent-primary-dark  focus:bg-accent-primary-dark  active:bg-accent-primary-dark  lg:grid"
              onClick={toggleMenu}
            >
              <CloseIcon />
              <span className="sr-only">Close menu</span>
            </button>
          </div>

          <div className="mt-5 lg:mt-12 lg:flex lg:justify-start lg:gap-5 lg:px-26 xl:px-44">
            {menuGroups?.map((menuGroup, index) => {
              return (
                <FoldOutMenuSubMenu
                  key={`${menuGroup.title}-${index}`}
                  id={index.toString()}
                  menuGroup={menuGroup}
                  isMobile={isMobile}
                />
              );
            })}
          </div>

          <div className={styles.cardHolder}>
            <RenderBlocks blocks={menuCards as unknown as BlockSections[]} />
          </div>
          <div className="mt-16 grid gap-5 lg:grid-cols-2 lg:px-26 xl:px-44">
            <div className="order-2 lg:order-1">
              <p className="text-center text-bodys text-brand-grey-3 lg:text-left">
                © Ingka Centres
                <br />
                2010-{new Date().getFullYear()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
